export default __webpack_public_path__ + "static/media/SndLowerCMagicC.23a72d75.mp3";